class ProductQuote {
	constructor(
		product_id,
		required_weight,
		product_name,
		category_name,
		category_id,
		serviceable_weight,
		grade,
		hsn_code,
		setBrand,
		input_type,
		item_id,
		gst
	) {
		if (typeof product_id === 'object') {
			Object.assign(this, product_id)
			return
		}

		this.product_id = product_id ? product_id : null
		this.product_name = product_name ? product_name : null
		this.category_name = category_name ? category_name : null
		this.category_id = category_id ? category_id : null

		this.required_weight = required_weight ? required_weight : null
		this.brand_available = setBrand ? 'ANY' : ''
		this.serviceable_weight = serviceable_weight ? serviceable_weight : null
		this.ex_price = null
		this.for_price = null
		this.tc_available = true
		this.brand_ordered = setBrand ? 'ANY' : ''
		this.grade = grade ? grade : null
		this.hsn_code = hsn_code ? hsn_code : null
		this.input_type = input_type ? input_type : null
		this.item_id = item_id ? item_id : null
		this.gst = gst != null && gst !== '' ? Number(gst) : null
	}
}

export default ProductQuote
